import React, { Fragment, useState } from "react";
import { SolidButton } from "../../global/SolidButton";

import {
  CircleDollarSign,
  Edit,
  Plus,
  SquareArrowOutUpRight,
  Trash2,
} from "lucide-react";
import { sponsorAppData } from "../../../data/sponsorAppData";
import { SmallSolidButton } from "../../global/SmallSolidButton";
import { BorderButton } from "../../global/BorderButton";
import { MyModal } from "../../global/MyModal";

export default function SponsorApps() {
  const [currentItem, setCurrentItem] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isDisabled, setDisabled] = useState(false);
  const [errors, setErrors] = useState({});
  const [appName, setAppName] = useState(null);
  const [icon, setIcon] = useState(null);
  const [des, setDes] = useState(null);
  const [coins, setCoins] = useState(null);
  const [socialLink, setSocialLink] = useState(null);
  const [deleteId, setDeleteId] = useState(null);

  return (
    <Fragment>
      <div className="w-full space-y-4 ">
        <div className="flex items-center justify-end ">
          <SolidButton
            onClick={() => setIsModalOpen(true)}
            children={
              <>
                <Plus className="w-4 h-4" />
                <span>Add App</span>
              </>
            }
          />
        </div>
        <div
          className="bg-white/80 dark:bg-slate-900/80
               backdrop-blur-xl rounded-2xl  
               border border-state-200/50 dark:border-slate-700/50 
                w-full 
                pb-4
               overflow-x-auto        
              "
        >
          <table className="min-w-full border-collapse ">
            <thead>
              <tr className="bg-slate-100 dark:bg-slate-800/60 border-t border-slate-300 dark:border-slate-700">
                <th className="text-start w-[400px] text-xs font-semibold text-slate-600 dark:text-slate-400 py-3 ps-4">
                  <input
                    type="text"
                    placeholder="Search by title or subtitle"
                    //      value={search}
                    //    onChange={(e) => setSearch(e.target.value)}
                    className="w-[300px] mr-4 text-xs py-2.5 px-4 bg-slate-400/20 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl text-slate-800 dark:text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all"
                  />
                </th>
                <th className="text-start text-xs font-semibold text-slate-600 dark:text-slate-400 py-3">
                  Coins
                </th>
                <th className="text-start space-e-10 px-4 text-xs font-semibold text-slate-600 dark:text-slate-400 py-3">
                  Created By
                </th>
                <th className="text-start text-xs font-semibold text-slate-600 dark:text-slate-400 py-3">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {sponsorAppData.map((item, index) => (
                <tr
                  key={index}
                  className="hover:bg-slate-100 dark:hover:bg-gray-800/20 border-b border-slate-300/40"
                >
                  <td className="text-start  py-2 ps-4">
                    <div className="flex items-center justify-start space-x-2">
                      <img
                        className="w-7 h-7"
                        src={item.icon}
                        alt="social icon"
                      />
                      <div className="flex flex-col justify-start">
                        <span className="flex items-center justify-start text-[11px] font-bold text-slate-900 dark:text-slate-200">
                          {item.name}
                          <SquareArrowOutUpRight
                            onClick={() => {
                              window.open(item.link, "_blank");
                            }}
                            className="ml-2 cursor-pointer text-blue-500"
                            size={14}
                          />
                        </span>
                        <p className="text-[11px] font-medium text-slate-500 dark:text-slate-400">
                          {item.des}
                        </p>
                      </div>
                    </div>
                  </td>

                  <td className="text-start py-2  ">
                    <div
                      onClick={() => {
                        window.open(item.link, "_blank");
                      }}
                      className="text-xs flex items-center justify-start space-x-1 font-semibold font-mono text-green-400 dark:text-green-500"
                    >
                      <CircleDollarSign className="w-[14px] h-[14px] text-amber-500" />

                      <span>{item.coins}</span>
                    </div>
                  </td>

                  <td className="text-start   py-2 px-4">
                    <div className="flex flex-col">
                      <span className="text-[12px]  font-medium text-slate-900 dark:text-slate-200">
                        Moon
                      </span>
                      <span className="text-[11px] font-medium text-slate-500 dark:text-slate-400">
                        {item.dateTime}
                      </span>
                    </div>
                  </td>

                  <td className="text-end pe-10">
                    <div className="flex items-center justify-start space-x-2">
                      <button
                        //    onClick={() => setDeleteId(item.id)}
                        className="flex items-center hover:bg-red-400/10 justify-center py-1  border border-gray-400/40 rounded-md px-2 cursor-pointer"
                      >
                        <span className="text-[10px] text-blue-400 font-medium mr-1">
                          Edit
                        </span>
                        <Edit size={12} className=" text-blue-400 " />
                      </button>
                      <button
                            onClick={() => setDeleteId(item.id)}
                        className="flex items-center hover:bg-red-400/10 justify-center py-1  border border-gray-400/40 rounded-md px-2 cursor-pointer"
                      >
                        <span className="text-[10px] text-red-400 font-medium mr-1">
                          Delete
                        </span>
                        <Trash2 size={12} className=" text-red-400 " />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {/* ADD / EDIT MODAL */}
      <MyModal
        isOpen={isModalOpen}
        title={isEditMode ? "Update App" : "Add New App"}
        onClose={() => setIsModalOpen(false)}
        width="560px"
      >
        <div className="w-full space-y-4 mt-4">
          {/* Platform */}
          <div>
            <label className="block text-xs font-medium text-slate-500 mb-1">
              App Name*
            </label>
            <input
              type="text"
              placeholder="E.g. Mangocash"
              value={appName}
              onChange={(e) => {
                setAppName(e.target.value);
                if (errors.appName)
                  setErrors((prev) => ({ ...prev, appName: undefined }));
              }}
              aria-invalid={!!errors.platform}
              className={`w-full text-xs py-2.5 px-4 bg-slate-400/20 dark:bg-slate-800 border rounded-xl text-slate-800 dark:text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all ${
                errors.appName
                  ? "border-red-400"
                  : "border-slate-200 dark:border-slate-700"
              }`}
            />

            {errors.appName && (
              <div className="text-xs text-red-500 mt-1">{errors.appName}</div>
            )}
          </div>
          {/* Icon */}
          <div>
            <label className="block text-xs font-medium text-slate-500 mb-1">
              Icon*
            </label>
            <input
              type="text"
              placeholder="E.g. https://upload.Youtube_logo.png"
              value={icon}
              onChange={(e) => {
                setIcon(e.target.value);
                if (errors.icon)
                  setErrors((prev) => ({ ...prev, icon: undefined }));
              }}
              aria-invalid={!!errors.icon}
              className={`w-full text-xs py-2.5 px-4 bg-slate-400/20 dark:bg-slate-800 border rounded-xl text-slate-800 dark:text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all ${
                errors.icon
                  ? "border-red-400"
                  : "border-slate-200 dark:border-slate-700"
              }`}
            />

            {errors.icon && (
              <div className="text-xs text-red-500 mt-1">{errors.icon}</div>
            )}
          </div>
          {/* Description */}
          <div>
            <label className="block text-xs font-medium text-slate-500 mb-1">
              Description*
            </label>
            <textarea
              type="text"
              placeholder="E.g. Join our Page"
              value={des}
              onChange={(e) => {
                setDes(e.target.value);
                if (errors.des)
                  setErrors((prev) => ({ ...prev, des: undefined }));
              }}
              aria-invalid={!!errors.des}
              className={`w-full h-20 text-xs py-2.5 px-4 bg-slate-400/20 dark:bg-slate-800 border rounded-xl text-slate-800 dark:text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all ${
                errors.des
                  ? "border-red-400"
                  : "border-slate-200 dark:border-slate-700"
              }`}
            />

            {errors.des && (
              <div className="text-xs text-red-500 mt-1">{errors.des}</div>
            )}
          </div>
          {/* Button Text */}
          <div>
            <label className="block text-xs font-medium text-slate-500 mb-1">
              Coins*
            </label>
            <input
              type="number"
              placeholder="E.g. Join Page"
              value={coins}
              onChange={(e) => {
                setCoins(e.target.value);
                if (errors.coins)
                  setErrors((prev) => ({ ...prev, coins: undefined }));
              }}
              aria-invalid={!!errors.coins}
              className={`w-full text-xs py-2.5 px-4 bg-slate-400/20 dark:bg-slate-800 border rounded-xl text-slate-800 dark:text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all ${
                errors.coins
                  ? "border-red-400"
                  : "border-slate-200 dark:border-slate-700"
              }`}
            />

            {errors.coins && (
              <div className="text-xs text-red-500 mt-1">{errors.coins}</div>
            )}
          </div>
          {/* Social Link */}
          <div>
            <label className="block text-xs font-medium text-slate-500 mb-1">
              Social Link*
            </label>
            <input
              type="text"
              placeholder="E.g. https://youtube.com"
              value={socialLink}
              onChange={(e) => {
                setSocialLink(e.target.value);
                if (errors.socialLink)
                  setErrors((prev) => ({ ...prev, socialLink: undefined }));
              }}
              aria-invalid={!!errors.socialLink}
              className={`w-full text-xs py-2.5 px-4 bg-slate-400/20 dark:bg-slate-800 border rounded-xl text-slate-800 dark:text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all ${
                errors.socialLink
                  ? "border-red-400"
                  : "border-slate-200 dark:border-slate-700"
              }`}
            />

            {errors.socialLink && (
              <div className="text-xs text-red-500 mt-1">
                {errors.socialLink}
              </div>
            )}
          </div>
          {/* action buttons */}
          <div className="flex space-x-4 justify-end mt-6">
            <BorderButton onClick={() => setIsModalOpen(false)}>
              <span className="text-sm text-slate-400">Cancel</span>
            </BorderButton>
            <SolidButton
              disabled={isDisabled}
              className="px-4 py-2 text-sm space-x-2"
              //   onClick={() => handleSubmit()}
            >
              {isEditMode ? "Update" : "Confirm"}
            </SolidButton>
          </div>
        </div>
      </MyModal>

      {/* DELETE CONFIRM MODAL */}
      <MyModal
        isOpen={!!deleteId}
        title="Delete App?"
        onClose={() => setDeleteId(null)}
      >
        <p className="text-sm text-slate-800 dark:text-slate-300 mt-4">
          Are you sure you want to delete this app?
        </p>

        <div className="flex justify-end space-x-3 mt-6">
          <button
            onClick={() => setDeleteId(null)}
            className="px-4 py-2 rounded-lg bg-slate-400/20 dark:bg-slate-800 text-sm"
          >
            Cancel
          </button>

          <SolidButton
            //  onClick={handleDelete}
            children={<span>Delete</span>}
          />
        </div>
      </MyModal>
    </Fragment>
  );
}
